<template>
  <div>
    <v-main>
      <div class="bg">
        <v-container>
          <div class="center nav">
            <v-icon style="position: absolute; left: 20px" @click="previous()"
              >mdi-arrow-left</v-icon
            >
            <v-spacer></v-spacer>
            <h2 style="margin-bottom: 0">Create account</h2>
            <v-spacer></v-spacer>
          </div>
          <!-- <div class="row">
            <div>1</div>
            <div >1</div>
          </div> -->
          <div class="content">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
            >
                <p>Email Address</p>
                <v-text-field
                v-model="Email"
                prepend-inner-icon="mdi-email-outline"
                solo
                flat
                hide-details
                placeholder="Your email address"
                style="border-radius: 20px"
                :rules="[rules.required, rules.email]"
                ></v-text-field>
                <p style="padding-top:10px">Password</p>
                <v-text-field
                v-model="password"
                placeholder="Your password"
                prepend-inner-icon="mdi-lock-outline"
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                solo
                flat
                hide-details
                style="border-radius: 20px"
                @click:append="showPass"
                @input="count()"
                @
                :rules="[rules.required, rules.lenghth]"
                ></v-text-field>
            </v-form>
            <div class="ff">
              <div>
                <p
                  style="
                    color: var(--neutral-grey-2, #858494);
                    font-family: Roboto;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 140%;
                    margin-bottom: 1px;
                    padding-top: 10px;
                  "
                >
                  Must be at least 8 characters.
                </p>
              </div>
              <div>
                <v-icon v-if="status_check === true" color="#25388D">mdi-check</v-icon>
              </div>
            </div>
          </div>
          <div class="progress1" style="padding-bottom: 15px">
            <span style="margin: 0; display: flex; justify-content: end">{{
              "1 / 2"
            }}</span>
            <v-progress-linear
              v-model="power"
              color="#25388D"
              height="8"
            ></v-progress-linear>
          </div>
          <div class="next center">
            <v-btn
              style="
                display: flex;
                height: 44px;
                padding: 16px 133px;
                justify-content: center;
                align-items: center;
                border-radius: 20px;
                background: var(--color-primary, #25388d);
              "
              dark
              block
              @click="next()"
              >NEXT</v-btn
            >
          </div>
        </v-container>
      </div>
    </v-main>
  </div>
</template>

<script>
// import google from './test.vue'
export default {
  name: 'LoyaltySystemSignUp',
  components: {
    // google
  },

  data () {
    return {
      status_check: false,
      power: 33,
      show2: false,
      Email: '',
      password: '',
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
        lenghth: v => v.length >= 8 || 'Must be at least 8 characters'
      }
    }
  },

  mounted () {
    console.log(this.password.lenghth)
  },

  methods: {
    previous () {
      window.location = 'http://localhost:8081/signUp'
    },
    next () {
      if (this.$refs.form.validate() === true) {
        this.$router.push(`createShop?password=${this.password}&Email=${this.Email}`)
      }
    },
    showPass () {
      this.show2 = !this.show2
      console.log(this.show2)
    },
    count () {
      if (this.password.length >= 8) {
        this.status_check = true
      }
      console.log(this.password.length)
    }
  }
}
</script>

<style scoped>
.progress {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  height: 8px !important;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e9ecef;
  border-radius: 0.5rem;
}
.container {
  padding: 12px 25px;
}
.ff {
  width: 100%;
  height: 1%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.ff div {
  display: flex;
  align-items: center;
  padding-bottom: 30px;
}

/*//////////////*/
.bg {
  background: var(--neutral-grey-5, #eef3fc);
  height: 100vh;
  display: flex;
  justify-content: center;
}
.center {
  display: flex;
  justify-content: center;
}
span {
  color: var(--neutral-grey-2, #858494);
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
a {
  text-decoration: none;
  color: var(--color-primary, #25388d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.nav {
  display: flex;
  align-items: center;
  height: 100px;
}
.nav div {
  display: flex;
  align-items: center;
}

.signUp {
  justify-content: center;
}
.btn-mail {
  border-radius: 20px;
  width: 327px;
  height: 24px;
}
.btn-face {
  border-radius: 20px;
  border: 2px solid var(--neutral-grey-4, #e6e6e6);
  width: 327px;
}
.btn-google {
  border-radius: 20px;
  display: flex;
  width: 327px;
  padding: 16px 133px;
  justify-content: center;
  align-items: center;
  height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/createAccount.vue